import { useState, type JSX } from 'react';
import { RouterProvider } from 'react-router';
import { Providers } from './app/providers';
import { createAppRouter } from './app/router';

export const App = (): JSX.Element => {
  const [router] = useState(createAppRouter);
  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
};
